<template>
    <v-dialog v-model="modal" :scrim="false" width="600">
        <v-card v-if="infoLoading" color="primary" dark>
            <v-card-text>
                {{ $t('loading') }}
                <v-progress-linear indeterminate color="white" class="mb-0" />
            </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-title class="d-flex justify-space-between text-wrap">
                {{ title }}
                <v-icon class="justify-end" @click="modal = false">mdi-close</v-icon>
            </v-card-title>
            <template v-if="mealTypes.length">
                <v-card-text v-for="(mealType, index) in mealTypes" :key="index">
                    <template
                        v-if="
                            mealType.shortDescription &&
                            (!mealType.description || mealType.description.indexOf(mealType.shortDescription) === -1)
                        "
                    >
                        <h4>{{ $t('description_type.short') }}</h4>
                        <div v-html="mealType.shortDescription" />
                    </template>
                    <template v-if="mealType.description">
                        <h4>{{ $t('description_type.general') }}</h4>
                        <div v-html="mealType.description" />
                    </template>
                </v-card-text>
            </template>
            <v-card-text v-else>
                {{ $t('no_details') }}
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_MEAL_TYPE_INFO_EVENT} from '@/utils/event-bus'

    @Component
    export class HotelMealTypeInfoModal extends Vue {
        infoLoading = false
        modal = false
        mealTypeNames = []
        hotel = null
        room = null
        hotelInfo = null

        mounted() {
            EventBus.$on(SHOW_MEAL_TYPE_INFO_EVENT, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_MEAL_TYPE_INFO_EVENT, this.showModal)
        }

        async showModal({hotel, mealTypeNames, room, hotelInfo = null}) {
            //hotelInfo is for orderDetails. we don't need to load hotelInfo

            this.mealTypeNames = mealTypeNames
            this.hotel = hotel
            this.room = room
            this.modal = true
            this.infoLoading = true

            if (hotelInfo) {
                this.hotelInfo = hotelInfo
            } else {
                this.hotelInfo =
                    hotelsRuntimeStore.getHotelsInfoByRoomOffer(this.room, this.hotel)?.hotelDescriptionInfo || null
                if (!this.hotelInfo) {
                    await hotelsRuntimeStore.loadHotelsInfoByOffer(hotel, [room.hotelSupplierCode])
                    this.hotelInfo =
                        hotelsRuntimeStore.getHotelsInfoByRoomOffer(this.room, this.hotel)?.hotelDescriptionInfo || null
                }
            }

            this.infoLoading = false
        }

        get title() {
            return this.mealTypeNames.join(', ')
        }

        get mealTypes() {
            const mealTypes = this.mealTypeNames
                .map(mealTypeName =>
                    this.hotelInfo?.mealTypes.mealType.find(mealType => mealType.name === mealTypeName)
                )
                .filter(mealType => mealType && (mealType.description || mealType.shortDescription))
            const roomMealType = mealTypes.find(({name}) => this.room.mealTypeName === name)
            if (this.room.mealType && (!roomMealType?.shortDescription || !roomMealType.description)) {
                if (roomMealType) {
                    Object.assign(roomMealType, this.room.mealType)
                } else {
                    mealTypes.push(this.room.mealType)
                }
            }
            return mealTypes
        }
    }

    export default HotelMealTypeInfoModal
</script>
